import { useContext, useEffect, useState } from 'react';
import { SerpResponse } from 'ts/hotel/interfaces/SerpResponse';
import { useLoadGoogle } from 'hooks/useLoadGoogle';
import GoogleTabContent from '../TripadvisorGoogle/GoogleTabContent';
import { useLocation } from 'react-router-dom';
import { getKey } from 'utils/hotel';
import { MainContext } from 'contexts/MainContext';
import { HotelConfigContext } from 'contexts/HotelConfigContext';
import { b2b } from 'constants/generic';
import Tabs from 'components/ui/Tabs/Tabs';

interface SerpDetailsProps {
  hotel: any;
  onLoad: () => void;
}

export const SerpDetails: React.FC<SerpDetailsProps> = ({ hotel, onLoad }) => {
  const { loadGoogle } = useLoadGoogle();
  const [res, setRes] = useState<SerpResponse>();
  const [activeTab, setActiveTab] = useState(2);
  const { search, pathname } = useLocation();
  const { hotelIndex } = useContext(HotelConfigContext);
  const { user } = useContext(MainContext);
  const searchToken = sessionStorage.getItem(getKey('searchTokenHotels', hotelIndex));
  useEffect(() => {
    const onHotelPage = pathname.includes('hotel');
    const onDetailsOrResults = pathname.includes('details') || pathname.includes('results');
    if (b2b && (!onHotelPage || !onDetailsOrResults)) {
      return;
    }
    if (!user?.isAuth) {
      return;
    }
    (async () => {
      const newRes = await loadGoogle('en', hotel, searchToken || '');
      if (newRes?.serpResults?.serpHotel) {
        setRes(newRes);
        onLoad();
      }
    })();
  }, [search]); //eslint-disable-line
  if (!res)
    return (
      <div className="details-block default-shadow">
        <div className="title-underline text-lg mb-20 title-header-grey">
          <div style={{ height: 20 }}></div>
        </div>
        <div style={{ height: 300 }}></div>
      </div>
    );
  return (
    <div className="details-block default-shadow hotel-info-serp">
      <div className="title-underline text-lg mb-20 title-header-grey">Google</div>
      <Tabs
        label="Google"
        value={String(activeTab)}
        onValueChange={(v) => setActiveTab(Number(v))}
        items={[
          { value: '0', label: 'Prices' },
          { value: '1', label: 'Overview' },
          { value: '2', label: 'Reviews' },
          { value: '3', label: 'Photos' },
        ]}
      />
      <div className="tab-content tab-content-serp">
        <GoogleTabContent res={res} activeTab={activeTab} />
      </div>
    </div>
  );
};
